import { useQuery } from '@apollo/client';
import { USER_QUERY } from '@app/graphql/queries';
import { configureScope } from '@sentry/react';
import { useTranslation } from 'react-i18next';
export const UserWatcher = () => {
    const { data } = useQuery(USER_QUERY, { fetchPolicy: 'network-only' });
    const { i18n } = useTranslation();
    if (data && data.user) {
        // Check language.
        if (data.user.language) {
            if (data.user.language !== i18n.language) {
                i18n.changeLanguage(data.user.language);
            }
        }
        // Setup sentry scope.
        const id = data.user._id;
        const email = data.user.email;
        const language = data.user.language;
        configureScope(scope => {
            scope.setUser({ id, email, language });
        });
    }
    return null;
};
